import React, { useEffect, useState } from 'react';
import { useHistory} from 'react-router-dom';
import { Button, Card, CardBody, Col, Container, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";
import axios from 'axios';
import Select from "react-select";
import { CheckDateIsToday, ConvertStringToFullMonth, ConvertStringToShortMonth, GetFullMonth } from '../components/utils/convert-date';
import ConfigData from '../config.json';
import avatar1 from '../assets/images/user-dummy-img.jpg';
import Swal from 'sweetalert2';

const Events = () => {
    const dateNow = new Date();
    const history = useHistory();
    const [titleRemind, setTitleRemind] = useState("No meetings in your calendar.");
    const [descRemind, setDescRemind] = useState("You can reserve a meeting room now.");
    const [selectRoomType, setSelectRoomType] = useState(null);
    const [isShowModal, setIsShowModal] = useState();
    const [isCanEdit, setIsCanEdit] = useState(false);
    const [dataEvents, setDataEvents] = useState([]);
    const [eventsCalendar, setEventCalendar] = useState([]);
    const [dataRemindEvent, setDataRemindEvent] = useState([]);
    const [ddlRoomType, setDdlRoomType] = useState([]);
    const [objEventDetail, setObjEventDetail] = useState({
        id: 0,
        id_room_type: 0,
        reserve_by_id_employee_general: 0,
        reserve_by_employee_id: "",
        reserve_start_date: "",
        reserve_start_time: "",
        reserve_end_date: "",
        reserve_end_time: "",
        reserve_all_day: "",
        event_name: "",
        event_description: "",
        room_name: "",
        room_color: "",
        room_location: "",
        user_full_name: "",
        user_pic: ""
    });

    useEffect(() => {
        LoadDataRoomType();
        LoadDataEvents();
        LoadDataRemindEvent();
    }, []);

    const OnClickDate = (info) => {
        let arrStart = info.dateStr.split("T");
        let dateStart = arrStart[0];
        let timeStart = (arrStart.length > 1) ? arrStart[1].substring(0, 5) : "";
        let paramEncode = btoa("0;" + dateStart + ";" + timeStart);
        history.push("/detail/" + paramEncode);
    };

    const OnClickEvent = (info) => {
        const userId = (sessionStorage.getItem("uid") !== "" && sessionStorage.getItem("uid") != null && sessionStorage.getItem("uid") !== undefined) ? sessionStorage.getItem("uid") : 0;
        let dataEventDetail = dataEvents.find(item => item.id.toString() === info.event.id.toString());
        setObjEventDetail(dataEventDetail);
        setIsCanEdit((userId.toString() === dataEventDetail.reserve_by_id_employee_general.toString()) ? true : false);
        setIsShowModal(!isShowModal);
    };

    const OnClickEditEvent = () => {
        let paramEncode = btoa(objEventDetail.id + ";;");
        history.push("/detail/" + paramEncode);
    };

    const OnClickDeleteEvent = () => {
        Swal.fire({
            title: 'Delete Booking',
            text: 'Do you want to delete this booking ?',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            confirmButtonColor: '#9B8F70',
        }).then((result) => {
            if(result.isConfirmed){
                DeleteEventDetail(objEventDetail.id);
            }
        });
    };

    const OnClickCloseModal = () => {
        setIsShowModal(!isShowModal);
    };

    const LoadDataEvents = () => {
        let url = ConfigData.API_URL + "event-reserve-room/?status=1";
        let token = "Bearer " + sessionStorage.getItem("tokenmeetingbcaf");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                setDataEvents(respData.data);
                SearchDataEvent(respData.data, "0");
            }
        })
        .catch(error => {
            console.log(error);
        });
    };

    const LoadDataRemindEvent = () => {
        const userId = (sessionStorage.getItem("uid") !== "" && sessionStorage.getItem("uid") != null && sessionStorage.getItem("uid") !== undefined) ? sessionStorage.getItem("uid") : 0;
        let url = ConfigData.API_URL + "event-reserve-room/search-remind-by-user?reserve_by_id=" + userId;
        let token = "Bearer " + sessionStorage.getItem("tokenmeetingbcaf");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                if(respData.data.length > 0){
                    setDataRemindEvent(respData.data);
                    setTitleRemind("You have got " + respData.data.length + " meeting.");
                    setDescRemind("See your scheduled events from your calendar");
                }else{
                    setTitleRemind("No meetings in your calendar.");
                    setDescRemind("You can reserve a meeting room now.");
                }
            }
        })
        .catch(error => {
            console.log(error);
        });
    };

    const LoadDataRoomType = () => {
        let url = ConfigData.API_URL + "room-type/ddl";
        let token = "Bearer " + sessionStorage.getItem("tokenmeetingbcaf");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDdlRoomType(arrData);
            }
        })
        .catch(error => {
            console.log(error);
            // handlerRespError(error, history);
        });
    };

    const SearchDataEvent = (data, id_room_type) => {
        let arrData = [];
        data.forEach(element => {
            if(id_room_type === element.id_room_type.toString() || id_room_type === "0"){
                const startDate = element.reserve_start_date + "T" + element.reserve_start_time;
                const endDate = element.reserve_end_date + "T" + element.reserve_end_time;
                const isAllDay = (element.reserve_all_day === "1") ? true : false;
                // console.log(startDate, endDate, isAllDay);
                const oData = {
                    id: element.id,
                    title: element.event_name,
                    start: startDate,
                    end: endDate,
                    allDay: isAllDay,
                    color: element.room_color,
                    roomType: element.id_room_type,
                };
                arrData.push(oData);
            }
        });
        setEventCalendar(arrData);
    };

    const DeleteEventDetail = (id) => {
        let url = ConfigData.API_URL + "event-reserve-room/" + id;
        let token = "Bearer " + sessionStorage.getItem("tokenmeetingbcaf");
        let userId = sessionStorage.getItem("uid");
        axios.delete(url, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                LoadDataRemindEvent();
                LoadDataEvents();
                setSelectRoomType(null);
                setIsShowModal(!isShowModal);
                Swal.fire({
                    icon: 'success',
                    title: 'Booking deleted !',
                    text: 'Your booking has been deleted.',
                    confirmButtonColor: '#9B8F70',
                });
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            Swal.fire({
                icon: 'error',
                title: 'Failed to delete the booking.',
                confirmButtonColor: '#9B8F70',
            });
        });
    };

    const customStylesDdlRoomType = {
        control: (provided) => ({
          ...provided,
          borderRadius: '20px',
        }),
      };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col sm={12} md={3} lg={3}>
                            <Row>
                                <Col lg={12}>
                                    <h4 className="remind-event-title">{titleRemind}</h4>
                                    <p className="remind-event-desc">{descRemind}</p>
                                    <Row>
                                        {(dataRemindEvent.length > 0) ? dataRemindEvent.map((item, key) => (
                                            <Col lg={12} className="remind-event-detail" key={"remind-event-" + key}>
                                                <Card className="remind-event-card">
                                                    <CardBody>
                                                        <Row>
                                                            <Col lg={12}>
                                                                <p className="remind-event-date mb-2">
                                                                    {(CheckDateIsToday(item.reserve_start_date) === true) ? "Up coming" : ConvertStringToShortMonth(item.reserve_start_date)}
                                                                </p>
                                                                <p className="remind-evnet-name  mb-1">
                                                                    {item.event_name}
                                                                </p>
                                                                <p className="remind-event-time  mb-2">
                                                                    {(item.reserve_all_day === "1") ? "All day" : item.reserve_start_time + " - " + item.reserve_end_time}
                                                                </p>
                                                                <Row className="remind-event-user align-items-center">
                                                                    <Col xs={2} sm={2} md={2} lg={2} className="text-center px-0">
                                                                        <img src={(item.user_pic !== "") ? ConfigData.IMAGE_USER_URL + item.user_pic : avatar1} alt="" className="remind-event-user-img" />
                                                                    </Col>
                                                                    <Col xs={10} sm={10} md={10} lg={10} className="ps-0">
                                                                        <p className="remind-event-user-title mb-0">Creator</p>
                                                                        <p className="remind-event-user-name mb-1">
                                                                            K.{item.user_full_name}
                                                                        </p>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        )) : (
                                            <Col lg={12}></Col>
                                        )}
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col sm={12} md={9} lg={9}>
                            <Row className="align-items-center">
                                <Col sm={12} md={6} lg={6} >
                                    <p className="event-calendar-title">
                                        {dateNow.getDate() + " " + GetFullMonth(dateNow.getMonth()) + " " + dateNow.getFullYear()}
                                    </p>
                                </Col>
                                <Col sm={12} md={6} lg={6}>
                                    <Select id="ddlRoomType"
                                        name="ddlRoomType"
                                        value={selectRoomType}
                                        onChange={(selected) => {
                                            setSelectRoomType(selected);
                                            SearchDataEvent(dataEvents, (selected !== null) ? selected.value : "0");
                                        }}
                                        options={ddlRoomType}
                                        styles={customStylesDdlRoomType}
                                        className="event-calendar-ddl-room-type float-end mb-2"
                                        isClearable={true}
                                        isSearchable={true}
                                        placeholder="All"
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <FullCalendar
                                        plugins={[
                                            BootstrapTheme,
                                            dayGridPlugin,
                                            timeGridPlugin,
                                            interactionPlugin,
                                        ]}
                                        initialView="dayGridMonth"
                                        headerToolbar={{
                                            left: "timeGridDay,timeGridWeek,dayGridMonth",
                                            center: "title",
                                            right: "prev today next",
                                        }}
                                        events={eventsCalendar}
                                        eventTimeFormat={{
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: false
                                        }}
                                        slotLabelFormat={{
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: false
                                        }}
                                        dayMaxEvents={true}
                                        dateClick={OnClickDate}
                                        eventClick={OnClickEvent}
                                        handleWindowResize={true}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/* Modal Event Detail */}
            <Modal id="modalEventDetail"
                isOpen={isShowModal}
                toggle={() => { setIsShowModal(!isShowModal); }}
                backdrop={'static'}
                className="event-calendar-detail"
                centered
            >
                {/* <ModalHeader id="modalEventDetailHeader" 
                    className="modal-title"
                    toggle={() => { setIsShowModal(!isShowModal); }}
                >
                </ModalHeader> */}
                <ModalBody>
                    <Row className="mb-4">
                        <Col md={12}>
                            <div className="float-end">
                                <Button type="button" onClick={OnClickEditEvent} className="me-1 ecd-btn-edit" style={{display: (isCanEdit === false) ? "none" : "inline-block"}}>
                                    Edit
                                </Button>
                                <Button type="button" onClick={OnClickDeleteEvent} className="mx-2 ecd-btn-delete" style={{display: (isCanEdit === false) ? "none" : "inline-block"}}>
                                    Delete
                                </Button>
                                <Button type="button" onClick={OnClickCloseModal} className="ms-1 btn-icon ecd-button-close">
                                    <i className="ri-close-line" />
                                </Button>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <p className="ecd-name mb-0 ms-2">{objEventDetail.event_name}</p>
                            <p className="ecd-desc mb-2 ms-2">{objEventDetail.event_description}</p>
                            <p className="ecd-date mb-2 ms-2">
                                <i className="ri-calendar-todo-fill ecd-color-gold"></i>&nbsp;&nbsp;
                                {ConvertStringToFullMonth(objEventDetail.reserve_start_date)}
                            </p>
                            <p className="ecd-time mb-2 ms-2">
                                <i className="ri-time-fill ecd-color-gold"></i>&nbsp;&nbsp;
                                {(objEventDetail.reserve_all_day === "1") ? "All day" : objEventDetail.reserve_start_time + " - " + objEventDetail.reserve_end_time}
                            </p>
                            <p className="ecd-location mb-3 ms-2">
                                <i className="ri-map-pin-2-fill ecd-color-gold"></i>&nbsp;&nbsp;
                                {objEventDetail.room_name}
                            </p>
                            <Row className="ecd-user align-items-center">
                                <Col xs={2} sm={2} md={2} lg={2} className="text-center px-0">
                                    <img src={(objEventDetail.user_pic !== "") ? ConfigData.IMAGE_USER_URL + objEventDetail.user_pic : avatar1} alt="" className="ecd-user-img" />
                                </Col>
                                <Col xs={10} sm={10} md={10} lg={10} className="ps-0">
                                    <p className="ecd-user-title mb-0">Creator</p>
                                    <p className="ecd-user-name mb-1">
                                        K.{objEventDetail.user_full_name}
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
};

export default Events;